import templateData from 'ProjectData/template'
import axios from 'axios'
import store from 'Store'

const state = {
  views: [],
  template: []
}

const getters = {
  getState (state) {
    return state
  }
}

const actions = {
  async fetchData ({ commit }) {
    const response = await axios
      .get(templateData)
    commit('setTemplate', response.data)

    const currentScene = store.getters['scenes/getCurrentScene']
    commit('setState', currentScene)
  }
}

const mutations = {
  setState (state, data) {
    state.views = data.views
    for (let view of state.views) {
      if (view.template !== undefined) {
        const template = state.template.find(tmpl => tmpl.name === view.template)
        if (template !== undefined) {
          Object.assign(view, template)
        }
      }
    }
  },
  setTemplate (state, data) {
    state.template = data.template.views
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
